import React from 'react'
import { SVGProps } from './types'

export const NavCampaign: React.FC<SVGProps> = ({
  size = 24,
  color = 'currentColor',
  onClick,
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      onClick={onClick && (() => onClick())}
    >
      <rect width="8" height="4" x="8" y="2" rx="1" ry="1" fill="none" />
      <path
        d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"
        fill="none"
      />
      <path d="M12 11h4" fill="none" />
      <path d="M12 16h4" fill="none" />
      <path d="M8 11h.01" fill="none" />
      <path d="M8 16h.01" fill="none" />
    </svg>
  )
}
